// src/contexts/AuthContext.js
import React, { createContext, useState, useCallback, useContext } from 'react';
import api from '../../../../services/api';
import { useNavigate } from 'react-router-dom';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const navigate = useNavigate();

  const [accessToken, setAccessToken] = useState(
    () => localStorage.getItem('accessToken')
  );
  const [user, setUser] = useState(
    () => JSON.parse(localStorage.getItem('user'))
  );
  const [isAuthenticated, setIsAuthenticated] = useState(
    () => !!localStorage.getItem('accessToken') && !!localStorage.getItem('user')
  );
  // убрали initialLoadComplete и loading теперь всегда false
  const loading = false;

  const logout = useCallback(() => {
    setAccessToken(null);
    setUser(null);
    setIsAuthenticated(false);
    localStorage.removeItem('accessToken');
    localStorage.removeItem('user');
    navigate('/');
  }, [navigate]);

  // не используем автоматический рефреш здесь, оставляем это за interceptor-ом
  const login = useCallback(
    async (username, password) => {
      try {
        const response = await api.post('/auth/login', { username, password });
        const { accessToken: token, user: loggedUser } = response;
        setAccessToken(token);
        setUser(loggedUser);
        setIsAuthenticated(true);
        localStorage.setItem('accessToken', token);
        localStorage.setItem('user', JSON.stringify(loggedUser));
        return true;
      } catch (err) {
        console.error('Login failed:', err);
        //logout();
        return false;
      }
    },
    [logout]
  );

  return (
    <AuthContext.Provider
      value={{
        accessToken,
        user,
        isAuthenticated,
        loading,
        login,
        logout,
        setAccessToken, // для interceptor-а
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
export default AuthContext;
